import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const ENGINEERING_MENU = {
  key: ROUTES.ENGINEERING.ROOT,
  label: TITLES[ROUTES.ENGINEERING.ROOT],
  environment: [DEV, STAGE, PROD],
};
